import { RecordStore, StoreState } from '@deqo/foundation';
import React, { useMemo } from 'react';
import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { UserLiteData } from '../../../api/ApiTypes';
import { Point } from '../../../platform/geom/Point';
import { Colors } from '../../../ui';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { SelectUserView } from '../../common/SelectUserView';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { AtsertWidget, AtsertWidgetAction, AtsertWidgetProps } from '../mentions/ext/MentionModule';

export class AtsertDongle extends RecordStore({
    open: false,
    at: null as Point,
    query: null as string,
    onAction: null as (action: AtsertWidgetAction, param?: any) => void,
}) implements AtsertWidget {

    public show(props: AtsertWidgetProps) {
        this.updateState({
            open: true,
            at: props.relativePosition,
            query: props.query,
            onAction: props.onAction,
        });
    }

    public hide() {
        this.updateState({ open: false });
    }
}

export type AtsertState = StoreState<AtsertDongle>;

export const useAtsertDongle = () => useMemo(() => new AtsertDongle(), []);

export const CommentAtsertView = ({ open, at, query, onAction }: AtsertState) => {
    if (!open) return null;

    const me = useResolve(ProfileModel);

    const onSelect = (user: UserLiteData) => {
        onAction('insert', {
            fromId: me.id,
            toId: user.id,
            value: user.name,
            tag: uuid('nodash').slice(0, 8),
        });
    };

    const style = {
        ...at.toCSS(),
        width: '18rem',
        height: '16.25rem',
        background: 'white',
        borderRadius: '.5rem',
        boxShadow: `0 0 0 1px ${Colors.border}`,
    };
    return <Flexer absolute style={style}>
        <SelectUserView title="Mention:" allowKeyboard search={query} onSelect={onSelect} />
    </Flexer>;
};
